import RolService from "../seguridad/service/rol";
import UsuarioService from "../seguridad/service/usuario";
import PermisoService from "../seguridad/service/permiso";
import ServiceBase from "../../servicebase";

export class SeguridadController extends ServiceBase {  
  private _usuario : UsuarioService | undefined = undefined;
  usuario = () => this._usuario = (this._usuario ?? new UsuarioService(this.urlAPI));

  private _rol : RolService | undefined = undefined;
  rol = () => this._rol = (this._rol ?? new RolService(this.urlAPI));

  private _permiso : PermisoService | undefined = undefined;
  permiso = () => this._permiso = (this._permiso ?? new PermisoService(this.urlAPI));
}